import React from "react";
import "./footer.css";
function Footer() {
  return <div className="footer">
     <p>Localisation : Mohammedia, Morooco</p>
  </div>;
}

export default Footer;